export default function getExpirationStringForAbonement(subscription: any): string {
  const period = subscription.period;
  const unitId = subscription.period_unit_id;
  let unitString = "";

  switch (unitId) {
    case 1:
      unitString = "день";
      break;
    case 2:
      unitString = "неделя";
      break;
    case 3:
      unitString = "месяц";
      break;
    case 4:
      unitString = "год";
      break;
    default:
      throw new Error("Неизвестная единица измерения времени");
  }

  // Склонение единиц измерения времени
  if (period > 1) {
    switch (unitId) {
      case 1:
        unitString = "дня";
        break;
      case 2:
        unitString = "недели";
        break;
      case 3:
        unitString = "месяца";
        break;
      case 4:
        unitString = "года";
        break;
    }
  }
  if (period === 0) {
    return 'Срок действия неограничен'
  }

  return `${period} ${unitString} (Срок действия)`;
}